import { Button } from '@/components/button/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

export interface LeavePageConfirmDialogProps {
  open: boolean
  onChangeOpen: (open: boolean) => void
  onClickCancelButton: VoidFunction
  onClickOkButton: VoidFunction
}

export const LeavePageConfirmDialog = ({
  open = false,
  onChangeOpen,
  onClickCancelButton,
  onClickOkButton,
}: LeavePageConfirmDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onChangeOpen}>
      <DialogContent hideClose>
        <DialogHeader>
          <DialogTitle className={cn('leading-6')}>Leaving this screen will stop the scan upload.</DialogTitle>
          <DialogDescription className={cn('!mt-4')}>
            Going back will cancel the upload, and you&apos;ll need to restart the process. Are you sure you want to
            exit?
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <div className={cn('flex gap-x-2')}>
            <Button type="button" variant="outline" size="sm" onClick={onClickCancelButton}>
              Cancel
            </Button>
            <Button type="button" variant="default" size="sm" onClick={onClickOkButton}>
              Ok
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
